import Vue from 'vue'
import { Api } from '@/core/api.js'
import { db_categories, db_products, db_collections, db_printlogs, db_error_logs, db_printlogs_android, db_login } from '@/database'
import { resolvePaginatedTotal } from '@/utils/pagination'
import { pickTemporalSourceProduct } from '@/utils/timerProductTemporalCollection'

const api = new Api()

// Triquiñuela para resetear el state
const getDefaultState = () => {
    return {
        labels: {},
        labelsOrdered: {},
        categories: {},
        predefined: {},
        resume: {},
        printed: {},
        last_label_update: typeof localStorage.last_label_update !== 'undefined' ? parseInt(localStorage.last_label_update) : false,
        printLogsAndroid: {},
        isPrinting: false,
        portraitDefaultTab: false,
        multiplePrint: {},
        multiplePrintCopy: {}
    }
}

// initial state
const state = getDefaultState()

const loadLocalForageInformation = async () => {
    state.portraitDefaultTab = await db_login.getItem('label_portrait_default_tab')
}

loadLocalForageInformation()

// getters
const getters = {
    getCollections: (state, getters, rootState) => {
        return state.predefined
    },

    getMultiplePrint: (state, getters, rootState) => {
        return state.multiplePrint
    },

    getCategories: (state, getters, rootState) => {
        let userRol = rootState.loginUser.local.user.rol
        const filteredCategories = {}
        Object.keys(state.categories).forEach(key => {
          if (!state.categories[key].roles || (state.categories[key].roles && (state.categories[key].roles.includes(userRol) || state.categories[key].roles.length == 0))) {
            filteredCategories[key] = state.categories[key]
          }
        })
        return filteredCategories
    },

    getSortedCategories: (state, getters, rootState) => {
        let userRol = rootState.loginUser.local.user.rol
        const filteredCategories = {}
        Object.keys(state.categories).forEach(key => {
          if (!state.categories[key].roles || (state.categories[key].roles && (state.categories[key].roles.includes(userRol) || state.categories[key].roles.length == 0))) {
            filteredCategories[key] = state.categories[key]
          }
        })
        return Object.values(filteredCategories).sort((a, b) => parseInt(a.order) - parseInt(b.order))
    },

    getSelectedCategory: (state, getters, rootState) => {
        for (var i in state.categories) {
            if (state.categories[i].selected) return state.categories[i]
        }
        return false
    },

    getResume: (state, getters, rootState) => {
        return state.resume
    },

    getLabelsPrinted: (state, getters, rootState) => {
        return state.printed
    },

    getLabels: (state, getters, rootState) => {
        return state.labels
    },
    getLabelsOrdered: (state, getters, rootState) => {
        return state.labelsOrdered
    },

    getLabelStates: (state, getters, rootState) => (id) => {
        var states = {}
        for (var i in state.labels) {
            var label = state.labels[i]
            for (var j in label.states) {
                if (!Object.keys(states)[label.states[j].id]) {
                    states[label.states[j].id] = label.states[j]
                }
            }
        }
        if (typeof id !== 'undefined') return states[id]
        return states
    },

    getStateByLabel: (state, getters, rootState) => (product, stateId) => {
        const productData = state.labels[product]
        if (!productData) return false
        const stateData = productData.states[stateId]
        if (!stateData) return false
        return stateData
    },

    getLabel: (state, getters, rootState) => (id) => {
        return state.labels[id]
    },

    getImagesDownloaded: (state, getters, rootState) => {
        return state.last_label_update
    },

    getPrintLogsAndroid: (state, getters, rootState) => {
        return state.printLogsAndroid
    },

    getIsPrinting: (state, getters, rootState) => {
        return state.isPrinting
    },

    getPortraitDefaultTab: (state, getters, rootState) => {
        return state.portraitDefaultTab
    }
}

// actions
const actions = {
    // Commonisimos, está en todos los modules
    getCountSync(context) {
        return new Promise((resolve, reject) => {
            var count = 0
            db_printlogs
                .iterate(function (value, key, iterationNumber) {
                    count++
                })
                .then(function () {
                    db_error_logs
                        .iterate(function (value, key, iterationNumber) {
                            count++
                        })
                        .then(function () {
                            // db_printlogs_android
                            //     .iterate(function(value, key, iterationNumber) {
                            //         count++
                            //     })
                            //     .then(function() {
                            //     })
                            resolve(count)
                        })
                })
        })
    },

    resetState({ commit }) {
        commit('resetState')
    },

    loadLabels(context, params) {
        log('loadLabels -> REFRESH: ', context.rootGetters['getRefresh'].products)
        log('loadLabels -> Connection: ', fnCheckConnection())
        if (context.rootGetters['getRefresh'].products && fnCheckConnection()) {
            return api
                .get('labels', {})
                .then(async function (response) {
                    var data = format(response.data.categories)
                    var dataDefault = format(response.data.default)
                    context.commit('setCategories', data.categories)
                    context.commit('setLabels', data.labels)
                    context.commit('setPredefined', dataDefault.categories)
                    const references = dataDefault.categories
                    context.dispatch('loadMultiplePrint', { categories: references })
                    context.commit('setRefreshProducts', false, { root: true })
                    // context.commit('setPredefined', dataDefault.categories);

                    await db_categories.clear()
                    // await db_products.clear()
                    await db_collections.clear()

                    _.forEach(_.values(data.categories), async function (value, key) {
                        await db_categories.setItem(value.id, value)
                    })

                    // verificar si los productos de db_products existe alguno que este en data.labels. Si no existe eliminarlo de db_products
                    const products = []
                    await db_products.iterate(function (value, key, iterationNumber) {
                        products.push(value)
                    })
                    log('products -> ', products)
                    // data.labels could be an object instead of an array. Convert to array if necessary.
                    const labelsArray = Array.isArray(data.labels) ? data.labels : Object.values(data.labels || {});
                    const productsToDelete = products.filter(product => !labelsArray.some(label => label.id === product.id));
                    log('productsToDelete -> ', productsToDelete)
                    _.forEach(productsToDelete, async function (value, key) {
                        await db_products.removeItem(value.id)
                    })

                    // agregar los productos de data.labels a db_products que no existan
                    const productsToAdd = labelsArray.filter(label => !products.some(product => product.id === label.id))
                    log('productsToAdd -> ', productsToAdd)
                    _.forEach(productsToAdd, async function (value, key) {
                        await db_products.setItem(value.id, value)
                    })

                    _.forEach(_.values(dataDefault.categories), async function (value, key) {
                        await db_collections.setItem(value.id, value)
                    })

                    // dados los productos de localforage, si tienen local_image añadirlo al producto de data.labels
                    const productsWithLocalImage = products.filter(product => product.local_image)
                    log('productsWithLocalImage -> ', productsWithLocalImage)
                    _.forEach(productsWithLocalImage, async function (value, key) {
                        // data.labels may be an object instead of an array
                        const labelsArray = Array.isArray(data.labels) ? data.labels : Object.values(data.labels || {});
                        const label = labelsArray.find(label => label.id === value.id);
                        if (label) {
                            label.local_image = value.local_image
                        }
                    })

                    if (context.rootGetters.getIsApp && parseInt(response.data.update) == 1) {
                        context.dispatch('processLabelsImage', data.labels)
                    }
                    // context.rootState.refresh.products = false
                })
                .catch((error) => {
                    logError(error)
                    loadLabelsOffline(context)
                })
        } else if (context.rootGetters['getRefresh'].products) {
            loadLabelsOffline(context)
        }
    },

    loadMultiplePrint(context, params) {
        const collections = params.categories
        //Collection = {id: {id: {state}}}
        if(collections && Object.keys(collections).length > 0) {
            const multiplePrint =Object.entries(collections).reduce((acc, [keyCollection, collectionValue]) => {
                let formatReference = []
                const reference = collectionValue.references
                if(reference && Object.keys(reference).length > 0) {
                    Object.entries(reference).filter(([key, referenceValue]) => {
                        // const state = referenceValue.states && Object.values(referenceValue.states).length > 0 ? Object.values(referenceValue.states)[0] : null
                        Object.values(referenceValue.states).forEach((state, index) => {
                            let productState = { ...referenceValue }
                            if (state) {
                                productState.states = { [state.id]: state }
                                const format = context.rootGetters['printer/getTemplates'](state.format)
                                if (!format || !format.fields || Object.keys(format.fields).length === 0) {
                                    productState.canPrint = true
                                } else {
                                    productState.canPrint = false
                                }
                                productState.fields = format && format.fields ? format.fields : {}
                                productState.collectionID = keyCollection
                                productState.referenceID = productState.id
                                productState.stateID = state.id
                                productState.state = state.name
                                productState.quantity = state.quantity
                                productState.id = productState.id + (index != 0 ? `-${index}` : '')
                                formatReference.push(productState)
                            }
                        })
                    })
                }
                acc[keyCollection] = formatReference
                return acc
            }, {})
            log('multiplePrint: ', multiplePrint)
            context.commit('setMultiplePrint', multiplePrint)
            context.commit('setMultiplePrintCopy', JSON.parse(JSON.stringify(multiplePrint)))
        }
    },

    loadLabelsResume(context, params) {
        return api.get('labels/resume', {}).then(function (response) {
            var data = formatResume(response.data)
            context.commit('setResume', data)
        })
    },

    loadLabelsPrinted(context, params) {
        return api.post('labels/printed', params).then(function (response) {
            if (!response || response.status === false || !response.data) {
                return Promise.reject(response)
            }
            var data = response.data
            context.commit('setLabelsPrinted', {
                data,
                requestedPage: params.number_pages
            })
            return data
        })
    },

    async sendLabelPrint(context, params) {
        if (fnCheckConnection()) {
            return api.post('labels/print', params).then(async function (response) {
                if (response) {
                    return true
                } else {
                    const currentTime = getCurrentTime(context)
                    params.current_print_time = currentTime
                    await db_printlogs.setItem(moment().valueOf(), params)
                    return false
                }
            })
        } else {
            const currentTime = getCurrentTime(context)
            params.current_print_time = currentTime
            await db_printlogs.setItem(moment().valueOf(), params)
        }
    },

    uploadFailedLabelsPrint(context, labels) {
        return new Promise((resolve, reject) => {
            // console.log('uploadFailedLabelsPrint', labels, labels.length)
            if (labels.length == 0) resolve()
            else {
                var numLabelsToUpload = 10
                var labelsUpload = labels.slice(0, numLabelsToUpload)
                if (fnCheckConnection()) {
                    // console.log('uploading...', labelsUpload)
                    api.post('labels/print/multiple/offline', {
                        data: JSON.stringify(labelsUpload)
                    }).then(function (response) {
                        if (!response || !response.status) {
                            _.forEach(_.values(labelsUpload), async function (value, key) {
                                value.error_uploading = true
                                await db_printlogs.setItem(moment(value.current_print_time).valueOf() + moment().milliseconds(), value)
                            })
                        }
                        labels = labels.slice(numLabelsToUpload)
                        context.dispatch('uploadFailedLabelsPrint', labels).then(() => {
                            resolve()
                        })
                    })
                } else {
                    _.forEach(_.values(labelsUpload), async function (value, key) {
                        value.error_uploading = true
                        await db_printlogs.setItem(moment(value.current_print_time).valueOf() + moment().milliseconds(), value)
                    })
                    labels = labels.slice(numLabelsToUpload)
                    context.dispatch('uploadFailedLabelsPrint', labels).then(() => {
                        resolve()
                    })
                }
            }
        })
    },

    uploadLabelsPrint(context, labels) {
        return new Promise((resolve, reject) => {
            // console.log('uploadFailedLabelsPrint', labels, labels.length)
            if (labels.length == 0) resolve()
            else {
                var numLabelsToUpload = 10
                var labelsUpload = labels.slice(0, numLabelsToUpload)
                if (fnCheckConnection()) {
                    // console.log('uploading...', labelsUpload)
                    api.post('labels/print/multiple', {
                        data: JSON.stringify(labelsUpload)
                    }).then(function (response) {
                        if (!response || !response.status) {
                            _.forEach(_.values(labelsUpload), async function (value, key) {
                                value.error_uploading = true
                                await db_printlogs.setItem(moment(value.current_print_time).valueOf() + moment().milliseconds(), value)
                            })
                        }
                        labels = labels.slice(numLabelsToUpload)
                        context.dispatch('uploadLabelsPrint', labels).then(() => {
                            resolve()
                        })
                    })
                } else {
                    _.forEach(_.values(labelsUpload), async function (value, key) {
                        value.error_uploading = true
                        await db_printlogs.setItem(moment(value.current_print_time).valueOf() + moment().milliseconds(), value)
                    })
                    labels = labels.slice(numLabelsToUpload)
                    context.dispatch('uploadLabelsPrint', labels).then(() => {
                        resolve()
                    })
                }
            }
        })
    },

    sendFailedLabelsPrint(context, params) {
        // console.log('sendFailedLabelsPrint')
        if (fnCheckConnection()) {
            var aLabelsPrint = []
            db_printlogs
                .iterate(function (value, key, iterationNumber) {
                    aLabelsPrint.push(value)
                })
                .then(function () {
                    // console.log(aLabelsPrint)
                    db_printlogs.clear()
                    return context.dispatch('uploadFailedLabelsPrint', aLabelsPrint)
                })
        } else {
            return true
        }
    },

    async addPrintError(context, params) {
        if (fnCheckConnection()) {
            return api.post(`labels/print/error`, { error: params.error, platform: params.platform, version: params.version })
        } else {
            const sNow = moment().format('YYYY-MM-DD HH:mm:ss')
            await db_error_logs.setItem(sNow, {
                error: params.error,
                created_date: sNow,
                platform: params.platform,
                version: params.version
            })
            return true
        }
    },

    async sendFailedPrintErrors(context) {
        if (fnCheckConnection()) {
            const aErrors = []

            return await db_error_logs
                .iterate(function (value, key, iIndex) {
                    aErrors.push(value)
                })
                .then(function () {
                    if (aErrors.length == 0) {
                        return true
                    }

                    return api.post('labels/print/multiple/error', { data: JSON.stringify(aErrors) }).then(async function (response) {
                        return await db_error_logs.clear().then(function () {
                            return true
                        })
                    })
                })
        }
    },

    sync(context, params) {
        if (fnCheckConnection()) {
            return api.get('labels/sync', {}).then(function (response) {
                return response.data
            })
        }
        return false
    },

    processLabelsImage(context, params) {
        var aImages = []
        var aLocalImages = []
        log('processLabelsImage -> ', context.getters['getImagesDownloaded'])
        for (var k in params) {
            var label = params[k]
            if (label.image && label.image != 'false' && label.image != 'null') {
                if (!context.getters['getImagesDownloaded'] || (label.last_update && context.getters['getImagesDownloaded'] < moment(label.last_update).valueOf())) {
                    // log('processLabelsImage -> label: ', label)
                    // log('processLabelsImage -> label.last_update: ', moment(label.last_update).valueOf())
                    // log('processLabelsImage -> getImagesDownloaded: ', context.getters['getImagesDownloaded'])
                    // log('DOWNLOAD IMAGE')
                    aImages.push(label)
                } else {
                    // log('NO DOWNLOAD IMAGE, VALIDATE ON LOCAL')
                    aLocalImages.push(label)
                }
            } else {
                // log('NO PRODUCT IMAGE')
            }
        }

        return context.dispatch('queueDownloadImages', aImages).then(() => {
            return context.dispatch('queueLocalImages', aLocalImages)
        })
    },

    queueLocalImages(context, queue) {
        return new Promise((resolve, reject) => {
            if (queue.length > 0) {
                var label = Object.assign({}, queue.pop())
                var imageName = label.image.split('/')
                imageName = imageName[imageName.length - 1]
                // console.log('queueDownloadImage -> imageName: ', imageName)
                let labelPath = label.local_image ? label.local_image : context.rootGetters.getPathFiles + 'images/' + imageName;
                window.resolveLocalFileSystemURL(
                    labelPath,
                    function (fileEntry) {
                        fileEntry.file(
                            async function (entry) {
                                // console.log('IMAGEN EXISTE!: ', entry)
                                label.local_image = labelPath
                                await db_products.setItem(label.id, label)
                                context.commit('setLabel', label)
                                return context.dispatch('queueLocalImages', queue)
                            },
                            function (e) {
                                // console.log('E2 Local Images - ', e)
                                // si no existe la imagen, descargarla
                                return context.dispatch('downloadLabelImage', { uri: label.image, finalPath: context.rootGetters.getPathFiles + 'images/' + imageName, label: label }).then(() => {
                                    return context.dispatch('queueLocalImages', queue)
                                })
                            }
                        )
                    },
                    function (e) {
                        // console.log('E1  Local Images - ', e)
                        // si no existe la imagen, descargarla
                        return context.dispatch('downloadLabelImage', { uri: label.image, finalPath: context.rootGetters.getPathFiles + 'images/' + imageName, label: label }).then(() => {
                            return context.dispatch('queueLocalImages', queue)
                        })
                    }
                )
            } else {
                resolve()
            }
        })
    },

    queueDownloadImages(context, queue) {
        return new Promise((resolve, reject) => {
            if (queue.length > 0) {
                var label = queue.pop()
                var imageName = label.image.split('/')
                imageName = imageName[imageName.length - 1]
                let labelPath = label.local_image ? label.local_image : context.rootGetters.getPathFiles + 'images/' + imageName;
                log('queueDownloadImage -> labelPath: ', labelPath)
                window.resolveLocalFileSystemURL(
                    labelPath,
                    function (fileEntry) {
                        fileEntry.file(
                            function (entry) {
                                // console.log(entry)
                                return context.dispatch('downloadLabelImage', { uri: label.image, finalPath: context.rootGetters.getPathFiles + 'images/' + imageName, label: label }).then(() => {
                                    return context.dispatch('queueDownloadImages', queue)
                                })
                            },
                            function (e) {
                                // console.log('E2 - ', e)
                                return context.dispatch('downloadLabelImage', { uri: label.image, finalPath: context.rootGetters.getPathFiles + 'images/' + imageName, label: label }).then(() => {
                                    return context.dispatch('queueDownloadImages', queue)
                                })
                            }
                        )
                    },
                    function (e) {
                        // console.log('E1 - ', e)
                        return context.dispatch('downloadLabelImage', { uri: label.image, finalPath: context.rootGetters.getPathFiles + 'images/' + imageName, label: label }).then(() => {
                            return context.dispatch('queueDownloadImages', queue)
                        })
                    }
                )
            } else {
                context.commit('setLastLabelUpdate', moment().valueOf())
                resolve()
            }
        })
    },

    downloadLabelImage(context, labelImage) {
        return new Promise((resolve, reject) => {
            var fileTransfer = new FileTransfer()
            fileTransfer.download(
                labelImage.uri,
                labelImage.finalPath,
                async function (entry) {
                    // console.log('Successful download...')
                    // console.log('download complete: ' + entry.toURL())

                    var label = Object.assign(labelImage.label)
                    label.local_image = labelImage.finalPath
                    await db_products.setItem(label.id, label)
                    context.commit('setLabel', label)
                    resolve()
                },
                function (error) {
                    log('download error source ' + error.source)
                    log('download error target ' + error.target)
                    log('upload error code' + error.code)

                    resolve()
                },
                null, // or, pass false
                {}
            )
        })
    },

    getPrintLogsAndroid: (context, params) => {
        const labels = {}
        return new Promise((resolve, reject) => {
            db_printlogs_android
                .iterate((value, key, iterationNumber) => {
                    labels[key] = value
                })
                .then(() => {
                    resolve(context.commit('setPrintLogsAndroid', labels))
                })
                .catch((error) => {
                    resolve(context.commit('setPrintLogsAndroid', {}))
                })
        })
    },

    getFilteredLogsAndroid: (context, params) => {
        let labels = {}
        let aux_labels = []
        const MAX_LABELS = 20
        return new Promise((resolve, reject) => {
            db_printlogs_android
                .iterate((value, key, iterationNumber) => {
                    // filter by status
                    if (params && params.status && params.status.includes(parseInt(value.status))) {
                        aux_labels[parseInt(key)] = value
                    }
                })
                .then(() => {
                    aux_labels.forEach((value, key) => {
                        if (Object.keys(labels).length < 20) {
                            labels[key] = value
                        }
                    })
                    return resolve(labels)
                })
                .catch((error) => {
                    return resolve({})
                })
        })
    },

    async addPrintLabelLogAndroid(context, params) {
        return await db_printlogs_android.keys().then(async (keys) => {
            let biggestNumber = 0

            keys.forEach((index) => {
                index = parseInt(index)
                if (index > biggestNumber) {
                    biggestNumber = index
                }
            })

            const index = (biggestNumber + 1).toString()
            params.id = index
            params.current_print_time = moment().format('YYYY-MM-DD HH:mm:ss')

            await db_printlogs_android.setItem(index, params)

            return true
        })
    },

    removePrintLabelLogAndroid(context, key) {
        log('--- removePrintLabelLogAndroid ---', key, typeof key)
        return new Promise((resolve, reject) => {
            db_printlogs_android
                .removeItem(key)
                .then(() => {
                    resolve()
                })
                .catch((error) => {
                    reject()
                })
        })
    },

    clearPrintLabelLog(context) {
        return new Promise((resolve, reject) => {
            db_printlogs_android
                .clear()
                .then(() => resolve())
                .catch((error) => reject())
        })
    },

    clearQueueItems(context, queue) {
        for (let index in queue) {
            context.commit('removeItemQueue', queue[index].id)
        }
    },

    sendPrintLabelLogAndroid_Queue(context, params) {
        log('--- sendPrintLabelLogAndroid_Queue --- ', Object.assign({}, params))
        return new Promise((resolve, reject) => {
            let aQueueIDs = JSON.parse(JSON.stringify(params.ids))
            let aQueueValues = JSON.parse(JSON.stringify(params.values))
            log('aQueueIDs -> ', aQueueIDs, aQueueIDs.length)
            log('aQueueValues -> ', aQueueValues)
            if (aQueueIDs.length == 0) {
                log('LANZO RESOLVE')
                resolve(aQueueValues)
            } else {
                var key = aQueueIDs.pop()
                db_printlogs_android
                    .getItem(key)
                    .then((value) => {
                        value.printed_date = moment().format('YYYY-MM-DD HH:mm:ss')
                        aQueueValues.push(value)
                        db_printlogs_android.removeItem(key).then(() => {
                            log('REMOVE ' + key + ' FROM PRINTER LABEL LOGS')
                            context.dispatch('sendPrintLabelLogAndroid_Queue', { ids: aQueueIDs, values: aQueueValues }).then((response) => {
                                resolve(response)
                            })
                        })
                    })
                    .catch((err) => {
                        log('CAN NOT REMOVE ' + key + ' FROM PRINTER LABEL LOGS')
                        context.dispatch('sendPrintLabelLogAndroid_Queue', { ids: aQueueIDs, values: aQueueValues }).then((response) => {
                            resolve(response)
                        })
                    })
            }
        })
    },

    sendPrintLabelLogAndroid(context, aQueueIDs) {
        return context.dispatch('sendPrintLabelLogAndroid_Queue', { ids: aQueueIDs, values: [] }).then((labels) => {
            return context.dispatch('uploadLabelsPrint', labels)
        })

        // const labels = []

        // db_printlogs_android
        //     .iterate((value, key, iterationNumber) => {
        //         if (aQueueIDs.includes(key)) {
        //             let item = Object.assign({}, value)
        //             item.printed_date = moment().format('YYYY-MM-DD HH:mm:ss')
        //             labels.push(item)
        //             await db_printlogs_android.removeItem(key)
        //         }
        //     })
        //     .then(() => {
        //         return context.dispatch('uploadFailedLabelsPrint', labels)
        //     })
        //     .catch(error => {
        //         return false
        //     })
    },

    resetQueue(context) {
        // if queue has corrupted items (with status 1) update with status 2
        return new Promise((resolve, reject) => {
            db_printlogs_android
                .iterate((value, key, iterationNumber) => {
                    if (parseInt(value.status) == 1) {
                        value.status = 2
                        context.commit('setItemQueue', value)
                    }
                })
                .then(() => {
                    resolve(true)
                })
                .catch((error) => {
                    logError(error)
                    reject(false)
                })
        })
    },

    getRelatedLabels(context, params) {
        if (fnCheckConnection()) {
            return api
                .post(`labels/related/fields`, { reference_id: params.reference_id, state_id: params.state_id, format_id: params.format_id })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    logError(error)
                    return { status: false }
                })
        } else {
            return { status: false }
        }
    },

    loadPrintedRelatedStates(context, params) {
        return api
            .post(`labels/related/printed/states`, { reference_id: params.reference_id, states: params.states, other_products: params.other_products })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                logError(error)
                return {}
            })
    },

    prepareTemporalCollection(context, params) {
        let collection = {
            id: 'tpm_' + moment().valueOf(),
            temporal: true,
            references: {}
        }

        params.forEach((reference) => {
            const labelProduct = context.state.labels[reference.id]
            const timerProduct = context.rootGetters['timerproduct/getProducts'](reference.id)
            const ref = pickTemporalSourceProduct(labelProduct, timerProduct, reference.state_id, reference.productSource)
            if (!ref || !ref.states || !ref.states[reference.state_id]) {
                return
            }
            if (typeof collection.references[reference.id] === 'undefined') {
                collection.references[reference.id] = {
                    id: reference.id,
                    name: reference.name ? reference.name : ref.name,
                    category_id: reference.category_id ? reference.category_id : ref.category_id,
                    image: reference.image ? reference.image : ref.image,
                    note: reference.note ? reference.note : ref.note,
                    states: {}
                }
            }

            if (!collection.references[reference.id].states[reference.state_id]) {
                collection.references[reference.id].states[reference.state_id] = {...ref.states[reference.state_id]}
                log('reference', reference)
                Object.keys(reference).forEach((key) => {
                    if (!['id', 'reference_id', 'state_id', 'productSource'].includes(key)) {
                        collection.references[reference.id].states[reference.state_id][key] = reference[key]
                    }
                })
            } else {
                let i = 0
                let bFound = false
                while (!bFound) {
                    i++
                    bFound = typeof collection.references[reference.id].states[reference.state_id + '_' + i] == 'undefined'
                }
                let keyState = reference.state_id + '_' + i
                log('reference',reference.id,'keyState', keyState)
                collection.references[reference.id].states[keyState] = {...ref.states[reference.state_id]}
                Object.keys(reference).forEach((key) => {
                    if (!['id', 'reference_id', 'state_id', 'productSource'].includes(key)) {
                        collection.references[reference.id].states[keyState][key] = reference[key]
                    }
                })
            }
        })

        context.commit('addPredefined', collection)
        return collection
    },

    removeTemporalCollection(context, id){
        context.commit('removePredefined',id)
    },

    uploadLabelImages(context, params){
        return api
            .post(`labels/print/convert/images`, { file: params.file, id: params.id})
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                logError(error)
                return {}
            })
    },
    resetMultiplePrint(context){
        context.commit('setMultiplePrint', context.state.multiplePrintCopy)
    },

    loadPreviousLabels(context, params) {
        return api
            .post(`labels/previous/label`, { barcode: params.barcode })
            .then((response) => {
                return response
            })
            .catch((error) => {
                logError(error)
                return {}
            })
    }
}

// mutations
const mutations = {
    // Commonisimos, está en todos los modules
    resetState(state) {
        Object.assign(state, getDefaultState())
    },

    setLabels(state, data) {
        // console.log("data");
        // console.log(JSON.stringify(data));
        var ordered = {}
        var aux = Object.values(data)
        aux.sort((a, b) => a.name.localeCompare(b.name, 'es', { numeric: true }))
        for (var i in aux) {
            var lab = aux[i]
            ordered[lab.id] = lab
        }
        // console.log("ordered");
        // console.log(JSON.stringify(ordered));
        state.labelsOrdered = ordered
        state.labels = data
    },

    setMultiplePrint(state, data) {
        state.multiplePrint = data
        Vue.set(state, 'multiplePrint', Object.assign(data))
    },

    setMultiplePrintCopy(state, data) {
        state.multiplePrintCopy = data
    },

    setLabel(state, label) {
        var labels = Object.assign(state.labels)
        var labelsOrdered = Object.assign(state.labelsOrdered)
        labels[label.id] = label
        labelsOrdered[label.id] = label

        state.labels = labels
        state.labelsOrdered = labelsOrdered
        Vue.set(state, 'labels', Object.assign(labels))
        Vue.set(state, 'labelsOrdered', Object.assign(labelsOrdered))
    },

    setResume(state, data) {
        state.resume = data
    },

    setLabelsPrinted(state, payload) {
        const hasPaginationMetadata = payload && Object.prototype.hasOwnProperty.call(payload, 'requestedPage')
        const data = hasPaginationMetadata ? payload.data : payload
        const requestedPage = hasPaginationMetadata ? payload.requestedPage : 1
        const nextData = data && typeof data === 'object' ? data : {}

        state.printed = Object.assign({}, nextData, {
            results: resolvePaginatedTotal(nextData.results, state.printed.results, requestedPage)
        })
    },

    setCategories(state, data) {
        state.categories = data
    },
    setPredefined(state, data) {
        state.predefined = data
    },
    addPredefined(state, data) {
        let predefined = Object.assign(state.predefined)
        predefined[data.id] = data
        state.predefined = predefined
        Vue.set(state, 'predefined', Object.assign(predefined))
    },
    removePredefined(state, id){
        let predefined = Object.assign(state.predefined)
        // Elimina la propiedad predefined[id] y guarda el cambio en el store
        if (predefined.hasOwnProperty(id)) {
            delete predefined[id];
            state.predefined = predefined;
            Vue.set(state, 'predefined', Object.assign({}, predefined));
        }
    },

    selectCategory(state, category) {
        if (category == false || category == 'false') {
            for (var k in state.categories) {
                var cat = state.categories[k]
                cat.selected = false
            }
        } else {
            for (var k in state.categories) {
                var cat = state.categories[k]
                if (cat.id == category.id) {
                    cat.selected = true
                } else {
                    cat.selected = false
                }
            }
        }
        Vue.set(state, 'categories', { ...state.categories })
    },

    selectPredefined(state, predef) {
        if (predef == false) {
            for (var k in state.predefined) {
                var cat = state.predefined[k]
                cat.selected = false
            }
        } else {
            for (var k in state.predefined) {
                var cat = state.predefined[k]
                if (cat.id == predef.id) {
                    cat.selected = true
                } else {
                    cat.selected = false
                }
            }
        }
        Vue.set(state, 'predefined', { ...state.predefined })
    },

    referenceStateSelected(state, data) {
        state.predefined[data.collectionID].references[data.referenceID].states[data.stateID].selected = data.selected
    },

    referenceStateCompleted(state, data) {
        state.predefined[data.collectionID].references[data.referenceID].states[data.stateID].completed = true
    },

    referenceStateCurrentQuantity(state, data) {
        state.predefined[data.collectionID].references[data.referenceID].states[data.stateID].currentQuantity = data.currentQuantity
    },

    referenceStateReset(state, data) {
        for (let collectionID in state.predefined) {
            for (let referenceID in state.predefined[collectionID].references) {
                let reference = state.predefined[collectionID].references[referenceID]

                for (let stateID in reference.states) {
                    let state = reference.states[stateID]

                    // remove completed, selected and current quantity
                    delete state.completed
                    delete state.selected
                    delete state.currentQuantity
                }
            }
        }
    },

    async setLastLabelUpdate(state, value) {
        log('setLastLabelUpdate -> value: ', value)
        state.last_label_update = value
        await localStorage.setItem('last_label_update', value)
    },
    setPrintLogsAndroid(state, labels) {
        state.printLogsAndroid = labels
        Vue.set(state, 'printLogsAndroid', { ...state.printLogsAndroid })
    },
    setIsPrinting(state, value) {
        state.isPrinting = value
        Vue.set(state, 'isPrinting', value)
    },
    async setItemQueue(state, value) {
        let printLogs = { ...state.printLogsAndroid }
        printLogs[value.id] = value
        Vue.set(state, 'printLogsAndroid', { ...state.printLogsAndroid })
        state.printLogsAndroid = { ...printLogs }
        await db_printlogs_android.setItem(value.id, value)
    },
    async removeItemQueue(state, id) {
        let logsAndroid = { ...state.printLogsAndroid }
        delete logsAndroid[id]
        state.printLogsAndroid = { ...logsAndroid }
        Vue.set(state, 'printLogsAndroid', logsAndroid)
        await db_printlogs_android.removeItem(id)
    },
    async updateQueueStatus(state, params) {
        for (let index in params.queue) {
            let queueItem = params.queue[index]
            queueItem.status = params.status
            state.printLogsAndroid[queueItem.id] = queueItem
            await db_printlogs_android.setItem(queueItem.id, queueItem)
        }
        Vue.set(state, 'printLogsAndroid', { ...state.printLogsAndroid })
    },
    async setPortraitDefaultTab(state, value) {
        state.portraitDefaultTab = value
        Vue.set(state, 'portraitDefaultTab', value)
        await db_login.setItem('label_portrait_default_tab', value)
    }
}

function format(raw) {
    var categories = {}
    var labels = {}

    var found = false

    for (var k in raw) {
        var cat = raw[k]
        cat.visible = false
        cat.selected = false
        if (!found) {
            // cat.selected = true;
            found = true
        }
        categories[cat.id] = cat

        for (var i in cat.references) {
            var label = cat.references[i]
            label.category_id = cat.id
            labels[label.id] = label
        }
    }

    return { categories: categories, labels: labels }
}

function formatResume(raw) {
    var resume = {}

    var today = moment().startOf('day')

    for (var i in raw) {
        var oDay = {
            date: moment(i * 1000),
            isToday:
                moment(i * 1000)
                    .startOf('day')
                    .unix() == today.unix(),
            product: {}
        }

        resume[i] = oDay

        for (var j in raw[i]) {
            var label = raw[i][j]

            var oProduct = {
                reference_id: label.reference_id,
                id: label.id,
                name: label.name,
                quantity: label.quantity,
                created_date: moment(label.created_date * 1000),
                end_date: moment(label.end_date * 1000),
                alert: label.alert,
                showing: true,
                toExpire: false,
                expired: false
            }

            if (oDay.isToday) {
                oProduct = calculate_expiration(oProduct)
            }

            resume[i].product[label.id] = oProduct
        }
    }

    return resume
}

function calculate_expiration(oProduct) {
    var now = moment()
    if (oProduct.end_date.isBefore(now)) {
        // console.log("before");

        if (now.diff(oProduct.end_date, 'hours') > 2) {
            // console.log("NOT SHOW NOT NOT");
            oProduct.showing = false
        } else {
            // console.log("EXPIRED");
            oProduct.expired = true
        }
    } else if (oProduct.end_date.isAfter(now)) {
        // console.log("after");
        if (oProduct.end_date.diff(now, 'hours') < 1) {
            // console.log("TO EXPIRE");
            oProduct.toExpire = true
        }
    }

    return oProduct
}

function loadLabelsOffline(context) {
    let categories = {}
    let labels = {}
    let collections = {}
    db_categories
        .iterate(function (value, key, iterationNumber) {
            categories[key] = value
        })
        .then(function () {
            return db_products.iterate(function (value, key, iterationNumber) {
                labels[key] = value
            })
        })
        .then(async function () {
            return await db_collections.iterate(function (value, key, iterationNumber) {
                collections[key] = value
            })
        })
        .then(function () {
            if (_.size(_.keys(categories)) > 0) {
                context.commit('setCategories', categories)
            }
            if (_.size(_.keys(labels)) > 0) {
                context.commit('setLabels', labels)
            }
            if (_.size(_.keys(collections)) > 0) {
                context.commit('setPredefined', collections)
            }
        })
}

function getCurrentTime(context) {
    let response = ''
    let date = moment()

    const serverTimeDifference = context.rootGetters['getServerTimeDifference']
    const timezone = context.rootGetters['getTimeZoneName']
    const dateLimitation = context.rootGetters['getDateLimitation']

    const options = {
        timeZone: timezone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
    }

    const copy = moment(date)
    const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
    const objectDate = {}

    for (const item of dateTimeFormat) {
        objectDate[item.type] = item.value
    }

    const dateString = `${objectDate['day'].padStart(2, '0')}/${objectDate['month'].padStart(2, '0')}/${objectDate['year']} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}`

    date = moment(dateString, 'DD/MM/YYYY HH:mm')

    if (dateLimitation == 0 && date.diff(copy, 'minutes') != serverTimeDifference) {
        const difference = serverTimeDifference - date.diff(copy, 'minutes')
        date = date.add(difference, 'minutes')
    }

    response = date.format('YYYY-MM-DD HH:mm')

    return response
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
